module.exports = __webpack_public_path__ + "img/修改备注.98b28258.png";